const mediaTypes = {
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO'
};
export const toMediaType = value => {
  const mediaType = mediaTypes[value];
  return mediaType || undefined;
};
export const isMediaType = value => mediaTypes[value] !== undefined;